import type { ReactNode } from 'react';

import { cn } from '@pesto/utils';
import { CopyIcon } from 'lucide-react';

import { useClipboard } from '../hooks/useClipboard';
import { ScrollArea } from './ScrollArea';

const overflowClasses = {
  'break-all': 'break-all',
  scrollable: 'whitespace-nowrap',
  truncate: 'truncate',
} as const;

type OverflowClasses = typeof overflowClasses;

type DetailRowProps = {
  title: string;
  overflow?: keyof OverflowClasses;
  onCopy?: () => void;
} & ({ copyEnabled: true; value: string } | { copyEnabled?: false; value: ReactNode });

export const DetailRow = (props: DetailRowProps) => {
  const { title, overflow = 'break-all', onCopy } = props;
  const { copy } = useClipboard();

  const valueContent = <div className={cn(overflowClasses[overflow], 'text-foreground')}>{props.value}</div>;

  return (
    <div className="text-primary/60 w-full px-4 py-1 font-medium">
      <span className="whitespace-nowrap">{title}</span>
      <div className="flex">
        {overflow === 'scrollable' ? (
          <ScrollArea orientation="horizontal" className="max-w-full">
            {valueContent}
          </ScrollArea>
        ) : (
          valueContent
        )}
        {props.copyEnabled && (
          <button
            onClick={() => {
              void copy(props.value);
              onCopy?.();
            }}
          >
            <CopyIcon />
          </button>
        )}
      </div>
    </div>
  );
};
